"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogin = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _reactQuery = require("react-query");

var _hooks = require("../../checkout/hooks");

var _api = require("../api");

var _types = require("../types");

var _utility = require("../utility");

var _context = require("../context");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useLogin = function useLogin() {
  var context = _react["default"].useContext(_context.AuthContext);

  var queryClient = (0, _reactQuery.useQueryClient)();
  var setOrder = (0, _hooks.useOrder)().setOrder;
  /* istanbul ignore next */

  if (!context) {
    throw new Error('useLogin must be used within an AuthProvider');
  }

  var dispatch = context.dispatch;
  return (0, _reactQuery.useMutation)(function (_a) {
    var username = _a.username,
        password = _a.password,
        fingerprintID = _a.fingerprintID,
        recaptchaToken = _a.recaptchaToken;
    return (0, _api.login)({
      username: username,
      password: password,
      fingerprintID: fingerprintID,
      recaptchaToken: recaptchaToken
    });
  }, {
    onSuccess: function onSuccess(data) {
      dispatch({
        type: _context.AuthActions.LOGIN
      });
      queryClient.setQueryData(_types.QueryKeys.Account, (0, _tslib.__assign)((0, _tslib.__assign)({}, data), {
        aid: data.accountId
      }));
      (0, _utility.setToken)(data.jwt);
      setOrder({
        paymentInfo: undefined,
        paymentToken: undefined
      });
    },
    onError: function onError(error) {
      var _a;

      var _b = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) || {},
          text = _b.text,
          code = _b.code;

      Sentry.getCurrentHub().withScope(function (scope) {
        scope.setExtras({
          exceptionMessage: text,
          exceptionCode: code,
          hook: 'useLogin'
        });
        scope.setTags({
          "package": 'api/account',
          api: _types.Endpoints.Login
        });
        Sentry.getCurrentHub().captureException(new Error(text));
      });
    }
  });
};

exports.useLogin = useLogin;